import { render, staticRenderFns } from "./duty-edit.vue?vue&type=template&id=3f2289ad&scoped=true"
import script from "./duty-edit.vue?vue&type=script&lang=js"
export * from "./duty-edit.vue?vue&type=script&lang=js"
import style0 from "./duty-edit.vue?vue&type=style&index=0&id=3f2289ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2289ad",
  null
  
)

export default component.exports